/* HS funnel-tracking (pakket D, 23-aug-2026) — meet de drie stappen die tot nu toe
   onzichtbaar waren tussen collectie en checkout:

     select_item          klik op een productkaart: welk product, welke positie, welke lijst
     hs_view_cart         de winkelwagen-drawer gaat open, met de actuele inhoud
     tpd_filter_gebruikt  de bezoeker gebruikt de keuzehulp op een collectiepagina
     tpd_check_gebruikt   de bezoeker gebruikt de horloge-check op een productpagina

   Alles gaat UITSLUITEND naar de dataLayer; GTM (container GTM-W7NGCWTC) zet het door
   naar GA4 via de triggers "ce - select_item", "ce - hs_view_cart", "ce - tpd_gebruikt".
   Bewust geen tweede route via gtag(): twee routes kunnen dubbel tellen, en een gemist
   event is te repareren terwijl een dubbeltelling permanent in de historie blijft staan.

   Puur meten: dit script wijzigt niets aan de winkel. Faalt het, dan mist er hooguit
   een event (alle handlers zitten in try/catch).

   Terugdraaien: de render-regel in snippets/hs-clarity-lazy.liquid weghalen.
   Back-up en documentatie: .claude\pakket-d-23aug\ */
(function () {
  "use strict";
  if (window.__hsFunnelTracking) return;
  window.__hsFunnelTracking = true;

  var GEBRUIKT = {}; /* onthoudt eenmalige events per pagina */

  function stuur(naam, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: naam };
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
      }
      window.dataLayer.push(payload);
    } catch (e) {
      /* meten mag de winkel nooit breken */
    }
  }

  /* Ecommerce-events eerst resetten, anders lekken items van het vorige event door. */
  function stuurEcommerce(naam, ecommerce, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
    } catch (e) {}
    var payload = { ecommerce: ecommerce };
    for (var k in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
    }
    stuur(naam, payload);
  }

  function tekst(el) {
    return el && el.textContent ? el.textContent.replace(/\s+/g, " ").trim() : "";
  }

  /* ---------------------------------------------------------------- select_item */

  /* Shopify vult window.meta.products op collectie- en productpagina's met id,
     vendor, type, handle en varianten. Daarmee kunnen we een volwaardig GA4-item
     bouwen zonder de kaart-snippets aan te passen. */
  function zoekProduct(handle) {
    try {
      var lijst = (window.meta && window.meta.products) || [];
      for (var i = 0; i < lijst.length; i++) {
        if (lijst[i] && lijst[i].handle === handle) return lijst[i];
      }
      if (window.meta && window.meta.product && window.meta.product.handle === handle) {
        return window.meta.product;
      }
    } catch (e) {}
    return null;
  }

  function zoekVariant(product, variantId) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (variantId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
      }
    }
    return product.variants[0];
  }

  function prijsUitDom(kaart) {
    var el = kaart && kaart.querySelector(".price-item--regular, .price-item");
    if (!el) return undefined;
    var ruw = tekst(el).replace(/[^\d,.]/g, "").replace(/\./g, "").replace(",", ".");
    var n = parseFloat(ruw);
    return isNaN(n) ? undefined : n;
  }

  function lijstNaam(kaart) {
    var pad = location.pathname || "/";
    var inHoofdgrid = !!(kaart.closest && kaart.closest("#product-grid"));
    var collectie = pad.match(/\/collections\/([^\/?#]+)/);
    if (inHoofdgrid && collectie) return "collectie: " + collectie[1];

    var sectie = kaart.closest ? kaart.closest(".shopify-section, section") : null;
    var kop = sectie ? sectie.querySelector("h2, h1, .title") : null;
    if (kop && tekst(kop)) return tekst(kop).slice(0, 70);
    if (collectie) return "collectie: " + collectie[1];
    return "lijst op " + pad;
  }

  function positieIn(kaart) {
    var ouder = kaart.parentElement;
    if (!ouder) return undefined;
    var index = Array.prototype.indexOf.call(ouder.children, kaart);
    return index >= 0 ? index + 1 : undefined;
  }

  document.addEventListener(
    "click",
    function (e) {
      try {
        var doel = e.target;
        if (!doel || !doel.closest) return;

        /* knoppen in een kaart (bijv. direct bestellen) zijn geen kaartklik */
        if (doel.closest("button, [type=submit]")) return;

        var link = doel.closest('a[href*="/products/"]');
        if (!link) return;

        /* alleen kliks binnen een kaart in een lijst tellen mee */
        var kaart = link.closest(".grid__item, .card-wrapper");
        if (!kaart) return;
        /* de positie in het raster komt van het lijst-item, niet van de kaart
           erbinnen: de kaart is enig kind en zou altijd positie 1 opleveren */
        var rij = link.closest(".grid__item") || kaart;

        var href = link.getAttribute("href") || "";
        var handle = (href.match(/\/products\/([^\/?#]+)/) || [])[1];
        if (!handle) return;
        var variantId = (href.match(/[?&]variant=(\d+)/) || [])[1];

        var product = zoekProduct(handle);
        var variant = zoekVariant(product, variantId);
        var naamEl = kaart.querySelector(".card__heading");
        var lijst = lijstNaam(kaart);

        var item = {
          item_id: product ? String(product.id) : handle,
          item_name: (variant && variant.name) || tekst(naamEl) || handle,
          item_list_name: lijst,
          quantity: 1
        };
        if (product && product.vendor) item.item_brand = product.vendor;
        if (product && product.type) item.item_category = product.type;
        if (variant && variant.public_title) item.item_variant = variant.public_title;
        if (variantId) item.item_variant_id = String(variantId);
        var positie = positieIn(rij);
        if (positie) item.index = positie;
        var prijs = variant && typeof variant.price === "number"
          ? variant.price / 100
          : prijsUitDom(kaart);
        if (typeof prijs === "number") item.price = prijs;

        stuurEcommerce(
          "select_item",
          {
            currency: "EUR",
            value: typeof prijs === "number" ? prijs : undefined,
            item_list_name: lijst,
            items: [item]
          },
          { hs_label: item.item_name.slice(0, 100), hs_context: lijst }
        );
      } catch (err) {
        /* stil falen: een gemiste meting mag nooit een klik blokkeren */
      }
    },
    true
  );

  /* --------------------------------------------------------------- hs_view_cart */

  function stuurWinkelwagen() {
    try {
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || !cart.items.length) return;
          var items = cart.items.map(function (r, i) {
            var item = {
              item_id: String(r.product_id),
              item_name: r.product_title || r.title,
              quantity: r.quantity,
              price: (r.final_price || r.price || 0) / 100,
              index: i + 1
            };
            if (r.vendor) item.item_brand = r.vendor;
            if (r.variant_title) item.item_variant = r.variant_title;
            return item;
          });
          stuurEcommerce(
            "hs_view_cart",
            {
              currency: (cart.currency || "EUR"),
              value: (cart.total_price || 0) / 100,
              items: items
            },
            { hs_context: "drawer", hs_label: "winkelwagen geopend" }
          );
        })
        .catch(function () {});
    } catch (e) {}
  }

  function volgDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || drawer.__hsGevolgd) return;
    drawer.__hsGevolgd = true;
    var wasOpen = drawer.classList.contains("active");
    var laatste = 0;

    new MutationObserver(function () {
      var open = drawer.classList.contains("active");
      if (open && !wasOpen) {
        var nu = Date.now();
        if (nu - laatste > 1500) { /* dubbele class-mutaties tellen als een opening */
          laatste = nu;
          stuurWinkelwagen();
        }
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }

  /* ------------------------------------------------------------------ keuzehulp */

  function meldEenmalig(sleutel, naam, label, context) {
    if (GEBRUIKT[sleutel]) return;
    GEBRUIKT[sleutel] = true;
    stuur(naam, { hs_label: label, hs_context: context });
  }

  function volgKeuzehulp() {
    /* collectiepagina: filterblok "Filter op uw horloge" */
    var filter = document.getElementById("HsCollectieFilter");
    if (filter && !filter.__hsGevolgd) {
      filter.__hsGevolgd = true;
      var meldFilter = function (e) {
        var el = e.target;
        if (!el || !el.id) return;
        meldEenmalig("filter", "tpd_filter_gebruikt", el.id, "collectie");
      };
      filter.addEventListener("change", meldFilter, true);
      filter.addEventListener("input", meldFilter, true);
    }

    /* productpagina: horloge-check "Geschikt voor uw horloge?" */
    var check = document.querySelector(".hs-check, [class^='hs-check'], [class*=' hs-check']");
    var checkSectie = check ? (check.closest(".shopify-section, section") || check) : null;
    if (checkSectie && !checkSectie.__hsGevolgd) {
      checkSectie.__hsGevolgd = true;
      var meldCheck = function (e) {
        var el = e.target;
        if (!el || !el.tagName) return;
        if (!/^(INPUT|SELECT|BUTTON|OPTION)$/.test(el.tagName)) return;
        meldEenmalig("check", "tpd_check_gebruikt", el.id || el.name || el.tagName, "productpagina");
      };
      checkSectie.addEventListener("change", meldCheck, true);
      checkSectie.addEventListener("input", meldCheck, true);
      checkSectie.addEventListener("click", meldCheck, true);
    }
  }

  function start() {
    try { volgDrawer(); } catch (e) {}
    try { volgKeuzehulp(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  /* secties kunnen later inladen (drawer wordt herrenderd na toevoegen) */
  window.addEventListener("load", start);
})();
